var pug = require("!../../../../../node_modules/.pnpm/pug@2.0.4/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (ariaLabel, categoryNames, isParent) {pug_html = pug_html + "\u003Cdiv class=\"col-sm-1\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-8\"\u003E";
// iterate categoryNames
;(function(){
  var $$obj = categoryNames;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var item = $$obj[pug_index0];
if (item.isTail) {
pug_html = pug_html + "\u003Cdiv\u003E";
if (isParent) {
pug_html = pug_html + "\u003Ca" + (" class=\"next-level\""+" href=\"javascript:void(0)\""+pug.attr("aria-label", ariaLabel, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = item.name) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = item.name) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cspan class=\"inactive\"\u003E" + (pug.escape(null == (pug_interp = item.name) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var item = $$obj[pug_index0];
if (item.isTail) {
pug_html = pug_html + "\u003Cdiv\u003E";
if (isParent) {
pug_html = pug_html + "\u003Ca" + (" class=\"next-level\""+" href=\"javascript:void(0)\""+pug.attr("aria-label", ariaLabel, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = item.name) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = item.name) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cspan class=\"inactive\"\u003E" + (pug.escape(null == (pug_interp = item.name) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";}.call(this,"ariaLabel" in locals_for_with?locals_for_with.ariaLabel:typeof ariaLabel!=="undefined"?ariaLabel:undefined,"categoryNames" in locals_for_with?locals_for_with.categoryNames:typeof categoryNames!=="undefined"?categoryNames:undefined,"isParent" in locals_for_with?locals_for_with.isParent:typeof isParent!=="undefined"?isParent:undefined));;return pug_html;};
module.exports = template;